module.exports = __webpack_public_path__ + "img/quard9.d279b189.png";